<template>
  <div class="input-coupon-code">
    <slot name="txtBefore"></slot>
    <SimonModal
      v-if="!promoCodeRedeemedAndNotChanged"
      :is-visible="show_"
      @hide="back"
      id="input-coupon-code-modal"
      show-footer-buttons
      @btnLeft="back"
      @btnRight="codeSubmitHandler"
      :btn-left-title="getSlotText('btnPrev', 'Abbrechen')"
      :btn-right-title="!promoCodeRedeemedAndNotChanged ? getSlotText('btnNextCheck', 'Gutschein prüfen') : getSlotText('btnNextRedeem', 'Gutschein einlösen')"
      :loading-right-btn="loading"
    >
      <template v-slot:modalTitle>
          <h1><slot name="txtCouponInsertModalTitle">Gutschein? Sauber!</slot></h1>
      </template>
      <div class="coupon-modal-body">
        <div class="form-wrapper">
          <b-form
            :id="'form' + _uid"
            @submit.prevent="checkCode()"
          >
            <b-form-group  class="mandatory coupon-code-form-group" :class="vflowGetFeedbackClassesPromoCode()" >
              <label for="promoCode">
                <slot name="txtCouponInsertCodeModalLabel">Gutscheincode</slot>
              </label>
              <b-form-input
                name="promoCode"
                ref="promoCode"
                required
                v-model="promoCode"
                autocomplete="off"
                @input="$v.promoCode.$touch"
                @focus="vflowInputFocused('promoCode'); blurred_ = true; checkPromoCodeFailed = false;"
                @blur="vflowInputBlurred('promoCode'); blurred_ = true"
                @change="removeRedeemedStatus()"
                @input.native="removeRedeemedStatus()"
              ></b-form-input>
            </b-form-group>
          </b-form>
        </div>
        <slot name="txtAfter"></slot>
      </div>
    </SimonModal>

    <SimonModal
      v-else
      :is-visible="show_"
      @hide="back"
      id="input-coupon-code-modal"
      show-footer-buttons
      @btnLeft="back"
      @btnRight="codeSubmitHandler"
      :btn-left-title="getSlotText('btnPrev', 'Abbrechen')"
      :btn-right-title="!promoCodeRedeemedAndNotChanged ? getSlotText('btnNextCheck', 'Gutschein prüfen') : getSlotText('btnNextRedeem', 'Gutschein einlösen')"
      :loading-right-btn="loading"
      show-accordion
      accordion-title="Rechtliche Hinweise"
      :accordion-text="getSlotText('getModalInfoBoxTerms', '')"
    >
      <template v-slot:modalTitle>
        <h1>
          <slot name="txtCouponRedeemModalTitle">Dein Gutschein</slot>
        </h1>
      </template>
      <slot :name="getModalInfoBoxSubline"></slot>
      <div v-if="promotionBookingUrl" class="info-box-copytext">
        <slot name="txtCouponInsertCodeModalDocumentLink">Deine Vertragszusammenfassung findest du</slot> <span class="download-link-contract" @click="downloadDocumentWithAuth" >hier</span>.
      </div>
      <slot name="txtAfter"></slot>
    </SimonModal>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { maxLength, required } from 'vuelidate/lib/validators'
import isValid from '@/mixins/validators/isValid'
import { BForm, BFormGroup, BFormInput } from 'bootstrap-vue'
import { validationMixin } from 'vuelidate'
import validationFlow from '@/mixins/validators/validationFlow'
import syncProperty from '@/mixins/syncProperty'
import transaction from '@/mixins/transaction'
import beErrors from '@/mixins/beErrors'
import axios from 'axios'
import FileSaver from 'file-saver'
import appFileSaver from '@/mixins/appFileSaver'
import SimonModal from '@/components/modal/SimonModal.vue'

export default {
  name: 'CouponInsertCodeModalContract',
  data () {
    return {
      loading: false,
      promoCode: '',
      errorMsg: '',
      checkPromoCodeFailed: false,
      promoCodeRedeemedAndNotChanged: false,
      infoBoxVisible: false,
      promotionBookingUrl: null,
      isConfirmButton: false,
      countAutomaticInsert: 0,
      infoText: '',
      legalTermsText: '',
      promotionIDForSlots: null
    }
  },
  props: {
    redeemed: {
      type: Boolean,
      default: false
    },
    showModal: {
      type: Boolean,
      default: false
    },
    max50: {
      type: Number,
      default: 50
    },
    manualInsert: {
      type: Boolean,
      default: true
    }
  },
  components: {
    SimonModal,
    BForm,
    BFormGroup,
    BFormInput
  },
  computed: {
    ...mapGetters('promotion/promoCode', [
      'couponRedeemedContract',
      'validPromoCode',
      'couponTypeCredit',
      'couponTypeVolume',
      'validatedBookablePromotionData',
      'validatedBookablePromotion',
      'promoCodeAutomatic'
    ]),
    ...mapGetters([
      'accessToken'
    ]),
    getBackendErrorMessage: function () {
      return this.errorMsg
    },
    getModalInfoBoxSubline: function () {
      if (this.promotionIDForSlots) {
        return 'txtCouponRedeemedModalSublineContract' + this.promotionIDForSlots
      } else {
        return ''
      }
    },
    getModalInfoBoxTerms: function () {
      if (this.promotionIDForSlots) {
        return 'txtLegalTextsCouponRedeemedModal' + this.promotionIDForSlots
      } else {
        return ''
      }
    }
  },
  mixins: [
    validationMixin,
    isValid,
    transaction('changePassword'),
    syncProperty('show', 'show_'),
    validationFlow,
    beErrors,

    appFileSaver
  ],
  mounted () {
    this.resetInput()
  },
  updated () {
    // Prefilling only when automatically redeemed
    if (!this.manualInsert && this.countAutomaticInsert === 0) {
      this.promoCode = this.promoCodeAutomatic
      this.countAutomaticInsert++
      this.checkCode()
    }
  },
  methods: {
    ...mapActions('changePassword', [
      'changePassword'
    ]),
    ...mapActions('promotion/promoCode', [
      'checkPromoCode',
      'getValidPromoForPromoCode',
      'checkAndInitiatePromocodePromoContract',
      'resetPromoCodeState',
      'confirmPromocodePromoContract',
      'getSlotsIdForVoucherPromo'
    ]),
    ...mapMutations('promotion/promoCode', [
      'setPromotCodeAutomatic'
    ]),
    vflowGetFeedbackClassesPromoCode () {
      if (this.checkPromoCodeFailed) {
        return 'is-empty required-failed show-feedback'
      } else {
        return ''
      }
    },
    setClassForCheckList () {
      if (this.couponRedeemedContract && this.couponTypeVolume) {
        const otherContainer = document.getElementsByClassName('check-list')
        if (otherContainer.length !== 0) {
          for (const container of otherContainer) {
            container.classList.add('has-promo-1')
          }
        }
      }
    },
    removeClassForCheckList () {
      if (!this.couponRedeemedContract && !this.couponTypeVolume) {
        const otherContainer = document.getElementsByClassName('check-list')
        if (otherContainer.length !== 0) {
          for (const container of otherContainer) {
            container.classList.remove('has-promo-1')
          }
        }
      }
    },
    onInput () {
      this.$store.commit('clearMessages', {}, { root: true })
    },
    resetInput () {
      this.$store.commit('clearMessages', {}, { root: true })
      this.vflowResetFeedbackStates()
      this.promoCode = ''
    },
    codeSubmitHandler () {
      this.nextStep()
      if (this.promoCodeRedeemedAndNotChanged) {
        this.isConfirmButton = true
      }
    },
    nextStep () {
      if (!this.isConfirmButton) {
        this.checkCode()
      } else {
        this.confirmCode()
      }
    },
    checkCode () {
      if (this.promoCode !== '') {
        this.startLoader()

        this.checkAndInitiatePromocodePromoContract({ promotionCode: this.promoCode })
          .then((response) => {
            if (response) {
              if (response.errorMessage !== null && typeof response.errorMessage === 'string') {
                this.$emit('update:redeemed', false)
                this.checkPromoCodeFailed = false
                this.errorToast(response.errorMessage)

                const data = {
                  type: 'authentication',
                  message: response.errorMessage,
                  code: this.promoCode,
                  location: 'billedUsage-get'
                }
                if (typeof window.trackingNS?.track?.tracking === 'function') {
                  window.trackingNS.track.tracking('error', data)
                }
                this.removeClassForCheckList()
              } else {
                if (typeof response.promotion?.promotionId === 'number') {
                  this.getSlotsIdForVoucherPromo({ promotionId: response.promotion.promotionId })
                    .then((voucherPromotion) => {
                      this.promotionIDForSlots = voucherPromotion
                    })
                }
                const data = {
                  voucher_code: response.promotion?.promotionId,
                  voucher_action: 'display',
                  voucher_name: (typeof this.validatedBookablePromotion?.incentives[0].id !== 'undefined')
                    ? this.validatedBookablePromotion.incentives[0].id
                    : ''
                }
                if (typeof window.trackingNS?.track?.tracking === 'function') {
                  window.trackingNS.track.tracking('voucher', data)
                }
                this.checkPromoCodeFailed = false
                const baseUrl = this.$config.apiUrl
                this.promotionBookingUrl = response.initiatePromotionBookingUrl !== null
                  ? baseUrl + response.initiatePromotionBookingUrl
                  : null
                this.setFormInputValidClasses()
                this.$emit('update:redeemed', true)
                this.promoCodeRedeemedAndNotChanged = true
              }
            }
          })
          .catch(() => {
            this.loading = false
            this.$emit('update:redeemed', false)
            const message = this.beErrorGetLastMessage()
            this.errorToast(message)
            const data = {
              type: 'authentication',
              message: message,
              code: this.promoCode,
              location: 'billedUsage-get'
            }
            if (typeof window.trackingNS?.track?.tracking === 'function') {
              window.trackingNS.track.tracking('error', data)
            }
          })
          .finally(() => {
            this.stopLoader()
          })
      } else {
        this.checkPromoCodeFailed = true
      }
    },
    back () {
      this.$store.commit('clearMessages', {}, { root: true })
      this.show_ = false
    },
    closeModal () {
      this.checkPromoCodeFailed = false
      this.setPromotCodeAutomatic('')
      this.resetInput()
      this.removeRedeemedStatus()
      this.back()
    },
    /* sets green mark in the input field */
    setFormInputValidClasses () {
      const inputField = document.querySelector('.coupon-code-form-group')
      if (inputField !== null) {
        inputField.classList.add('is-not-empty')
        inputField.classList.add('is-valid')
      }
    },
    /* removes green mark in the input field */
    removeFormInputValidClasses () {
      const inputField = document.querySelector('.coupon-code-form-group')
      if (inputField !== null) {
        inputField.classList.remove('is-not-empty')
        inputField.classList.remove('is-valid')
      }
    },
    /* resets the status of the modal, removing info box, removing green checkmark etc */
    removeRedeemedStatus () {
      if (this.couponRedeemedContract) {
        this.promoCodeRedeemedAndNotChanged = false
        this.isConfirmButton = false
        this.infoBoxVisible = false
        this.removeFormInputValidClasses()
        this.resetPromoCodeState()
      }
    },
    /* second step, confirms the promo booking with a valid processID */
    confirmCode () {
      const _comp = this
      if (typeof this.validatedBookablePromotionData?.processId === 'string') {
        this.confirmPromocodePromoContract({ processId: this.validatedBookablePromotionData?.processId })
          .then((response) => {
            this.$emit('update:showModal', false)
            const data = {
              voucher_code: this.validPromoCode,
              voucher_action: 'apply',
              voucher_name: typeof this.validatedBookablePromotion?.incentives[0].id !== 'undefined' ? this.validatedBookablePromotion?.incentives[0].id : ''
            }
            if (typeof window.trackingNS?.track?.tracking === 'function') {
              window.trackingNS.track.tracking('voucher', data)
            }
            this.closeModal()
            this.successToast('Dein Gutschein wurde erfolgreich eingelöst! <br>' +
                'Dieser erscheint in deinem Kundenportal sobald ' +
                'der hinterlegte Vorteil aktiv ist.')
          }, () => {
            this.loading = false
            this.$emit('update:redeemed', false)
            const message = _comp.beErrorGetLastMessage()
            this.errorToast(message)
            const data = {
              type: 'authentication',
              message: message,
              code: this.promoCode,
              location: 'billedUsage-get'

            }
            if (typeof window.trackingNS?.track?.tracking === 'function') {
              window.trackingNS.track.tracking('error', data)
            }
          })
      }
    },
    downloadDocumentWithAuth (e) {
      if (e.preventDefault) e.preventDefault()
      if (e.stopPropagation) e.stopPropagation()
      const me = this
      const filename = 'Vertragszusammenfassung.pdf'

      axios.get(this.promotionBookingUrl, {
        baseURL: this.$config.apiUrl || '',
        headers: {
          Authorization: `Bearer ${this.accessToken}`,
          Accept: 'application/octet-stream'
        },
        responseType: 'blob'
      }).then((response) => {
        const file = new Blob([response.data], { type: 'application/octet-stream' })
        if (this.appTriggerSaveAsFileAvailable()) {
          this.appTriggerSaveAsFile(filename, file)
        } else {
          FileSaver.saveAs(file, filename)
        }
      }).catch((reason) => {
        this.errorMsg = this.getSlotText('errorNoContractDocumentAvailable', 'Ufff! Leider kann dat Dokument gerade nicht geladen werden (Fehler: VD1). Bitte probier\'s später noch einmal.')
        this.showError = true
        me.$store.commit('addError', 'Fehler beim Abrufen der Datei. (' + reason.response.status + ')')
      })
    }
  },
  validations () {
    return {
      promoCode: {
        required,
        maxLength: maxLength(this.max50)
      }
    }
  }
}
</script>
